var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('text-field-mask',{attrs:{"mask-format":"(##) #####-####","required":false,"label":" Ou informe o número de celular para contato"},on:{"update:value":function($event){_vm.phone = $event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }